<template>
  <layouts>
    <template #content>
      <div class="bg-gray-200 h-auto">
        <div class="container px-4 py-10 mx-auto max-w-7xl">
          <div class="flex items-center justify-between mb-6">
            <h1 class="text-2xl font-semibold text-gray-800">
              Booking Kalog
            </h1>
            <button
              @click="formDialog = true"
              class="ml-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
            >
              Tambah Data
            </button>
          </div>
          <div class="my-4" v-if="profileData.type_user == 'Super Admin'">
            <zselect
              class="w-64"
              v-model="filterStatus"
              :data="listOptionStatus"
              placeholder="Pilih Status"
              @input="refreshData"
            >
            </zselect>
          </div>

          <table-skeleton
            v-if="tableLoading"
            :columns="columns"
            :rows="listParams.limit > 10 ? 10 : listParams.limit"
          ></table-skeleton>
          <datatable
            v-else
            :data="data.data"
            :columns="columns"
            :meta="data.meta"
            :PageNavHandler="pageNavHandler"
            :TableInputSearchHandler="tableInputSearchHandler"
            :sortData="true"
            @sorting="sortingApply"
          >
            <!-- Custom Field -->
            <template v-slot:pickup_date="props">
              <span v-if="props.item.pickup_date">
                {{ formatDate(props.item.pickup_date) }}
              </span>
              <span v-else> - </span>
            </template>

            <template v-slot:price="props">
              <span v-if="!props.item.price">
                Rp. 0
              </span>
              <span v-else> Rp. {{ formatPrice(props.item.price) }} </span>
            </template>

            <!-- Origin -->
            <template v-slot:origin="props">
              {{ props.item.origin.name }}
            </template>

            <template v-slot:status="props">
              <span
                v-if="props.item.status == 'NOT_CONFIRM'"
                class="text-red-500"
              >
                {{ props.item.status }}
              </span>
              <span
                v-else-if="props.item.status == 'REQUESTED'"
                class="text-blue-500"
              >
                {{ props.item.status }}
              </span>
              <span v-else class="text-green-500">
                {{ props.item.status }}
              </span>
            </template>

            <!-- Destination -->
            <template v-slot:destination="props">
              {{ props.item.destination.name }}
            </template>

            <template v-slot:sender_name="props">
              {{ props.item.sender.name }}
            </template>

            <template v-slot:recipient_name="props">
              {{ props.item.recipient.name }}
            </template>

            <!-- Phone Number -->
            <template v-slot:sender_phone="props">
              {{ props.item.sender.phoneNumber }}
            </template>

            <template slot="action" slot-scope="props">
              <div class="flex items-center">
                <!-- approval -->
                <button
                  v-if="
                    props.item.status == 'REQUESTED' &&
                      !props.item.trackingCode &&
                      profileData.type_user == 'Super Admin'
                  "
                  @click="handleSubmit(props.item)"
                  class="bg-green-200 hover:bg-green-300 border border-green-300 hover:border-green-400 focus:border-green-400 rounded-md px-3 py-1 text-sm text-green-600 focus:outline-none flex items-center mr-2"
                >
                  <svg
                    class="w-5 h-5 mr-2 fill-current"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 2a8 8 0 100 16 8 8 0 000-16zm3.707 6.293a1 1 0 00-1.414-1.414L9 9.586l-1.293-1.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <h4 class="font-semibold">Approv</h4>
                </button>
                <button
                  @click="handleEdit(props.item.id)"
                  class="bg-gray-200 hover:bg-gray-300 border border-gray-300 hover:border-gray-400 focus:border-gray-400 rounded-md px-3 py-1 text-sm text-gray-600 focus:outline-none flex items-center mr-2"
                >
                  <svg
                    class="w-5 h-5 mr-2 fill-current"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                    <path
                      fill-rule="evenodd"
                      d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <h4 class="font-semibold">Edit</h4>
                </button>
                <!-- delete -->
                <button
                  @click="handleDelete(props.item.id)"
                  class="bg-red-200 hover:bg-red-300 border border-red-300 hover:border-red-400 focus:border-red-400 rounded-md px-3 py-1 text-sm text-red-600 focus:outline-none flex items-center"
                >
                  <svg
                    class="w-5 h-5 mr-2 fill-current"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v11a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 00-1-1H6zm3.5 4a.5.5 0 011 0v7a.5.5 0 01-1 0V6zm3.5.5a.5.5 0 00-1 0v7a.5.5 0 001 0V6.5zM8.5 6a.5.5 0 00-1 0v7a.5.5 0 001 0V6z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <h4 class="font-semibold">Delete</h4>
                </button>
                <!-- print -->
                <button
                  @click="handlePrint(props.item)"
                  class="bg-blue-200 hover:bg-blue-300 border border-blue-300 hover:border-blue-400 focus:border-blue-400 rounded-md px-3 py-1 text-sm text-blue-600 focus:outline-none flex items-center ml-2"
                >
                  <svg
                    class="w-5 h-5 mr-2 fill-current"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M5 4a1 1 0 00-1 1v2H3a2 2 0 00-2 2v6a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-1V5a1 1 0 00-1-1H5zm3.5 3a.5.5 0 011 0v4a.5.5 0 01-1 0V7zm3.5.5a.5.5 0 00-1 0v4a.5.5 0 001 0V7.5zM8.5 7a.5.5 0 00-1 0v4a.5.5 0 001 0V7z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <h4 class="font-semibold">Print</h4>
                </button>
              </div>
            </template>
            <!-- / End Custom Field -->
          </datatable>
        </div>
        <!-- Form Dialog -->
        <transition
          enter-active-class="ease-out duration-300"
          enter-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="opacity-100"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-show="formDialog"
            class="fixed inset-0 transition-opacity"
            aria-hidden="true"
          >
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>
        </transition>
        <transition
          enter-active-class="ease-out duration-300"
          enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-active-class="opacity-100 translate-y-0 sm:scale-100"
          leave-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <detailDataModal
            v-show="formDialog"
            title="Tambah Transaksi Kalog"
            desc="Isi form berikut untuk menambahkan transaksi baru."
            @close="handleClose"
          >
            <div class="p-6">
              <form @submit.prevent="saveTransaction" class="space-y-6">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2"
                      >Transaksi (JEX)</label
                    >
                    <textarea
                      v-model="formData.transactions"
                      rows="3"
                      class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="misal: JEX123456789, JEX987654321, JEX1122334455"
                    ></textarea>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2"
                      >Koli</label
                    >
                    <input
                      v-model.number="formData.koli"
                      type="number"
                      class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Jumlah Koli"
                    />
                  </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2"
                      >Weight (kg)</label
                    >
                    <input
                      v-model.number="formData.weight"
                      type="number"
                      step="0.1"
                      class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Berat (kg)"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2"
                      >Price</label
                    >
                    <zinputcurrency
                      v-model="formData.price"
                      placeholder="Rp50.000"
                    ></zinputcurrency>
                  </div>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2"
                    >Descriptions</label
                  >
                  <textarea
                    v-model="formData.descriptions"
                    rows="3"
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Deskripsi transaksi"
                  ></textarea>
                </div>

                <div class="bg-yellow-50 rounded-lg p-4">
                  <h3 class="text-lg font-medium text-gray-800 mb-4">
                    Origin (Asal)
                  </h3>
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-2"
                        >Tujuan Asal</label
                      >
                      <zautocomplete
                        v-model="formData.origin.name"
                        :data="originalData"
                        placeholder="Pilih Master Agen"
                        @input="
                          (selected) => {
                            formData.origin.id = selected.value;
                            formData.origin.name = selected.label;
                            formData.origin.city = selected.city;
                            formData.origin.latitude = selected.latitude;
                            formData.origin.longitude = selected.longitude;
                            formData.origin.address = selected.address;
                            formData.origin.phoneNumber = selected.phoneNumber;
                          }
                        "
                      >
                      </zautocomplete>
                    </div>
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-2"
                        >City</label
                      >
                      <input
                        v-model="formData.origin.city"
                        type="text"
                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Kota"
                        disabled
                      />
                    </div>
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-2"
                        >Latitude</label
                      >
                      <input
                        v-model="formData.origin.latitude"
                        type="text"
                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Latitude"
                        disabled
                      />
                    </div>
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-2"
                        >Longitude</label
                      >
                      <input
                        v-model="formData.origin.longitude"
                        type="text"
                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Longitude"
                        disabled
                      />
                    </div>
                    <div class="md:col-span-2">
                      <label
                        class="block text-sm font-medium text-gray-700 mb-2"
                        >Address</label
                      >
                      <input
                        v-model="formData.origin.address"
                        type="text"
                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Alamat Lengkap"
                        disabled
                      />
                    </div>
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-2"
                        >Phone Number</label
                      >
                      <input
                        v-model="formData.origin.phoneNumber"
                        type="text"
                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Nomor Telepon"
                        disabled
                      />
                    </div>
                  </div>
                </div>

                <div class="bg-yellow-50 rounded-lg p-4">
                  <h3 class="text-lg font-medium text-gray-800 mb-4">
                    Destination (Tujuan)
                  </h3>
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-2"
                        >Tujuan Asal</label
                      >
                      <zautocomplete
                        v-model="formData.destination.name"
                        :data="destinationData"
                        placeholder="Pilih Master Agen"
                        @input="
                          (selected) => {
                            formData.destination.id = selected.value;
                            formData.destination.name = selected.label;
                            formData.destination.city = selected.city;
                            formData.destination.latitude = selected.latitude;
                            formData.destination.longitude = selected.longitude;
                            formData.destination.address = selected.address;
                            formData.destination.phoneNumber =
                              selected.phoneNumber;
                          }
                        "
                      >
                      </zautocomplete>
                    </div>
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-2"
                        >City</label
                      >
                      <input
                        v-model="formData.destination.city"
                        type="text"
                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Kota"
                        disabled
                      />
                    </div>
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-2"
                        >Latitude</label
                      >
                      <input
                        v-model="formData.destination.latitude"
                        type="text"
                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Latitude"
                        disabled
                      />
                    </div>
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-2"
                        >Longitude</label
                      >
                      <input
                        v-model="formData.destination.longitude"
                        type="text"
                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Longitude"
                        disabled
                      />
                    </div>
                    <div class="md:col-span-2">
                      <label
                        class="block text-sm font-medium text-gray-700 mb-2"
                        >Address</label
                      >
                      <input
                        v-model="formData.destination.address"
                        type="text"
                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Alamat Lengkap"
                        disabled
                      />
                    </div>
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-2"
                        >Phone Number</label
                      >
                      <input
                        v-model="formData.destination.phoneNumber"
                        type="text"
                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Nomor Telepon"
                        disabled
                      />
                    </div>
                  </div>
                </div>

                <div class="bg-blue-50 rounded-lg p-4">
                  <h3 class="text-lg font-medium text-gray-800 mb-4">
                    Sender (Pengirim)
                  </h3>
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-2"
                        >Name</label
                      >
                      <input
                        v-model="formData.sender.name"
                        type="text"
                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Nama Pengirim"
                      />
                    </div>
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-2"
                        >Phone Number</label
                      >
                      <input
                        v-model="formData.sender.phoneNumber"
                        type="text"
                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Nomor Telepon Pengirim"
                      />
                    </div>
                    <div class="md:col-span-2">
                      <label
                        class="block text-sm font-medium text-gray-700 mb-2"
                        >Address</label
                      >
                      <input
                        v-model="formData.sender.address"
                        type="text"
                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Alamat Pengirim"
                      />
                    </div>
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-2"
                        >Zip Code</label
                      >
                      <input
                        v-model="formData.sender.zipCode"
                        type="text"
                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Kode Pos"
                      />
                    </div>
                  </div>
                </div>

                <div class="bg-green-50 rounded-lg p-4">
                  <h3 class="text-lg font-medium text-gray-800 mb-4">
                    Recipient (Penerima)
                  </h3>
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-2"
                        >Name</label
                      >
                      <input
                        v-model="formData.recipient.name"
                        type="text"
                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Nama Penerima"
                      />
                    </div>
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-2"
                        >Phone Number</label
                      >
                      <input
                        v-model="formData.recipient.phoneNumber"
                        type="text"
                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Nomor Telepon Penerima"
                      />
                    </div>
                    <div class="md:col-span-2">
                      <label
                        class="block text-sm font-medium text-gray-700 mb-2"
                        >Address</label
                      >
                      <input
                        v-model="formData.recipient.address"
                        type="text"
                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Alamat Penerima"
                      />
                    </div>
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-2"
                        >Zip Code</label
                      >
                      <input
                        v-model="formData.recipient.zipCode"
                        type="text"
                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Kode Pos"
                      />
                    </div>
                  </div>
                </div>
                <div class="flex justify-end space-x-4 pt-4">
                  <button
                    type="button"
                    @click="handleClose"
                    class="px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors"
                  >
                    Batal
                  </button>
                  <button
                    type="submit"
                    class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                  >
                    Simpan
                  </button>
                </div>
              </form>
            </div>
          </detailDataModal>
        </transition>
      </div>
    </template>
  </layouts>
</template>

<script>
import layouts from "@/components/layouts";
import datatable from "@/components/datatables/advance_table";
import tableSkeleton from "@/components/datatables/table_skeleton";
import zautocomplete from "@/components/zautocomplete";
import detailDataModal from "@/components/datatables/detail_modal";
import zselect from "@/components/zselect";
import Zinputcurrency from "../../components/zinputcurrency.vue";

import http from "@/config/http";
import { reactive, computed } from "@vue/composition-api";
import { useQueryClient } from "@tanstack/vue-query";
import {
  useBookingKalogistics,
  useKalogisticsOrigins,
  useKalogisticsDestinations,
} from "@/composables/booking/useBooking";
import { fetchBookingKalogisticsById } from "@/queries/api/booking";
import { keys } from "@/queries/keys";
export default {
  components: {
    layouts,
    zselect,
    datatable,
    tableSkeleton,
    zautocomplete,
    detailDataModal,
    Zinputcurrency,
  },
  setup() {
    const profile =
      JSON.parse(window.localStorage.getItem("data-profile-jaskipin")) || {};
    const listParams = reactive({
      page: 1,
      limit: 10,
      status: undefined,
      isMaster: profile && profile.type_user === "Super Admin",
    });
    const listQuery = useBookingKalogistics(computed(() => ({ ...listParams })));

    const { data: originsRaw } = useKalogisticsOrigins();

    const originIdRef = computed(() => {
      // referenced from data() formData.origin.id via this; we'll keep a separate ref
      return undefined;
    });
    // Destinations depend on a reactive originId, but Vue 2 setup() can't read data().
    // Use a separate reactive holder synced from watch in the options API.
    const destState = reactive({ originId: "" });
    const { data: destinationsRaw } = useKalogisticsDestinations(
      computed(() => destState.originId)
    );

    const qc = useQueryClient();
    return {
      listParams,
      bkqListData: listQuery.data,
      bkqListIsLoading: listQuery.isLoading,
      bkqListIsFetching: listQuery.isFetching,
      bkqListRefetch: listQuery.refetch,
      originsRaw,
      destinationsRaw,
      destState,
      originIdRef,
      qc,
    };
  },
  data() {
    return {
      /* Auth Token */
      /* Data List */
      listOptionStatus: [
        {
          label: "Semua",
          value: "",
        },
        {
          label: "REQUESTED",
          value: "REQUESTED",
        },
        {
          label: "NOT_CONFIRM",
          value: "NOT_CONFIRM",
        },
        {
          label: "CONFIRM",
          value: "CONFIRM",
        },
      ],
      filterStatus: "",
      formData: {
        // This will hold the form data, either for new or editing
        id: "",
        transactions: "",
        descriptions: "",
        origin: {
          id: "",
          name: "",
          city: "",
          latitude: "",
          longitude: "",
          address: "",
          phoneNumber: "",
        },
        destination: {
          id: "",
          name: "",
          city: "",
          latitude: "",
          longitude: "",
          address: "",
          phoneNumber: "",
        },
        koli: 0,
        weight: 0,
        price: "",
        sender: {
          name: "",
          address: "",
          phoneNumber: "",
          zipCode: "",
        },
        recipient: {
          name: "",
          address: "",
          phoneNumber: "",
          zipCode: "",
        },
      },
      dataSelected: [],
      columns: [
        {
          field: "trackingCode",
          label: "Kode Transaksi",
          sort: true,
        },
        {
          field: "sender_name",
          label: "Nama Pengirim",
          sort: true,
        },
        {
          field: "recipient_name",
          label: "Nama Penerima",
          sort: true,
        },
        {
          field: "weight",
          label: "Berat Barang",
        },
        {
          field: "koli",
          label: "Jumlah Koli",
        },
        {
          field: "price",
          label: "Harga",
        },
        {
          field: "descriptions",
          label: "Deskripsi",
        },
        {
          field: "sender_phone",
          label: "No Handphone",
        },
        {
          field: "pickup_date",
          label: "Tanggal Pickup",
          sort: true,
        },

        {
          field: "status",
          label: "Status Pickup",
        },
        {
          field: "origin",
          label: "Tujuan Asal",
        },
        {
          field: "destination",
          label: "Tujuan Kirim",
          sort: true,
        },
        {
          field: "action",
          label: "Aksi",
        },
      ],
      /* Filter */
      search: "",
      sort_by: "",
      sort_order: -1,
      filterDate: "Bulan Ini",
      start_date: "",
      end_date: "",
      /* Toggle Dialog */
      formDialog: false,
      // successNotification: false,
      // deleteConfirmModal: false,
      detailModal: false,
      /* Form Value */
      /* Extra Data */
    };
  },
  created: function() {
    // List/origins fetched automatically by useQuery; destinations triggered by watch.
  },

  computed: {
    profileData() {
      let profile = JSON.parse(
        window.localStorage.getItem("data-profile-jaskipin")
      );
      if (profile) {
        return profile;
      } else {
        return null;
      }
    },
    page: {
      get() {
        return this.listParams.page;
      },
      set(v) {
        this.listParams.page = v;
      },
    },
    limit: {
      get() {
        return this.listParams.limit;
      },
      set(v) {
        this.listParams.limit = v;
      },
    },
    data() {
      return this.bkqListData || [];
    },
    loading() {
      return this.bkqListIsLoading && !this.bkqListData;
    },
    tableLoading() { return this.bkqListIsFetching; },
    originalData() {
      const raw = this.originsRaw;
      const arr = raw && raw.data ? raw.data : [];
      return arr.map((item) => ({
        value: item.id,
        label: item.name,
        city: item.city,
        latitude: item.latitude,
        longitude: item.longitude,
        address: item.address,
        phoneNumber: item.phoneNumber,
      }));
    },
    destinationData() {
      const raw = this.destinationsRaw;
      const arr = raw && raw.data ? raw.data : [];
      return arr.map((item) => ({
        value: item.id,
        label: item.name,
        city: item.city,
        latitude: item.latitude,
        longitude: item.longitude,
        address: item.address,
        phoneNumber: item.phoneNumber,
      }));
    },
  },

  watch: {
    // Watch for changes in origin to update destState (drives useKalogisticsDestinations)
    "formData.origin.id": function(newVal) {
      this.destState.originId = newVal || "";
    },
  },

  methods: {
    /*
     * Get Data Method
     */
    async getListData(page, limit) {
      if (typeof page === "number") this.listParams.page = page;
      if (typeof limit === "number") this.listParams.limit = limit;
      this.listParams.status = this.filterStatus
        ? this.filterStatus.value
        : undefined;
      this.listParams.isMaster = this.profileData.type_user === "Super Admin";
      await this.bkqListRefetch();
    },

    async handleSubmit(data) {
      //   approve
      if (confirm("Apakah Anda yakin ingin mengkonfirmasi transaksi ini?")) {
        const payload = {
          ...data,
        };
        delete payload.id;
        delete payload.transactions;
        delete payload.updatedAt;
        await http
          .post(
            `/api/v1/booking/kalogistics/approve/${data.id}`,
            {
              ...payload,
            },
            { headers: this.headers }
          )
          .then((response) => {
            console.log(response);
            this.getListData(this.page, this.limit);
          })
          .catch((error) => {
            console.error(error);
            alert("Gagal mengkonfirmasi transaksi. Silakan coba lagi.");
          });
      }
    },
    /*
     * Pagination Handler Function
     */
    pageNavHandler(type) {
      switch (type) {
        case "previous":
          this.page -= 1;
          this.getListData(this.page, this.limit);
          break;
        case "next":
          this.page += 1;
          this.getListData(this.page, this.limit);
          break;
      }
    },

    async saveTransaction() {
      // Validasi form
      if (
        !this.formData.origin.id ||
        !this.formData.destination.id ||
        !this.formData.sender.name ||
        !this.formData.recipient.name ||
        this.formData.koli <= 0 ||
        this.formData.weight <= 0 ||
        !this.formData.price
      ) {
        alert("Mohon lengkapi semua field yang diperlukan.");
        return;
      }

      // Format price to number (only if it's a string)
      if (typeof this.formData.price === "string") {
        this.formData.price = parseFloat(
          this.formData.price.replace(/\./g, "")
        );
      }

      try {
        if (!this.formData.id) {
          await http.post(
            `/api/v1/booking/kalogistics`,
            this.formData,
            { headers: this.headers }
          );
        } else {
          await http.put(
            `/api/v1/booking/kalogistics/${this.formData.id}`,
            this.formData,
            { headers: this.headers }
          );
        }

        this.formDialog = false; // Close the dialog after saving
      } catch (error) {
        console.error(error);
      } finally {
        this.getListData(this.page, this.limit);
        // Reset form data after submission
        this.handleClose();
      }
    },

    /*
     * Edit Function
     */

    async handleEdit(id) {
      try {
        const result = await this.qc.fetchQuery({
          queryKey: [...keys.booking.all, "kalogistics", "detail", id],
          queryFn: () => fetchBookingKalogisticsById(id),
          staleTime: 5 * 60 * 1000,
        });
        this.formData = result && result.data ? result.data : result;
        this.formDialog = true; // Open the dialog for editing
      } catch (error) {
        console.error(error);
        alert("Gagal mengambil data untuk diedit. Silakan coba lagi.");
      }
    },

    /*
     * Delete Function
     */
    async handleDelete(id) {
      if (confirm("Apakah Anda yakin ingin menghapus data ini?")) {
        try {
          await http.delete(`/api/v1/booking/kalogistics/${id}`, {
          });
          this.getListData(this.page, this.limit);
        } catch (error) {
          console.error(error);
          alert("Gagal menghapus data. Silakan coba lagi.");
        }
      }
    },
    /*
     * Print Function
     */
    handlePrint(item) {
      sessionStorage.setItem("printItem", JSON.stringify(item));
      window.open(`/print/kalog/${item.id}`, "_blank");
    },
    /*
     * Search Function
     */
    tableInputSearchHandler(event) {
      const value = event.target.value; // ambil value dari form input search

      if (value === "") {
        this.search = ""; // Mengkosongkan kembali state querynya
        this.getListData(this.page, this.limit);
      } else {
        this.search = value;
        this.getListData(1, this.limit); // Ketika Filter Search dilakukan tidak bisa jika diset pagenya diatas 1 kalau hasil recordnya gak lebih dari limit/10 record
      }
    },

    /*
     * Reset Function
     */
    handleClose() {
      this.formDialog = false; // Close the dialog
      this.formData = {
        transactions: "",
        descriptions: "",
        origin: {
          id: "",
          name: "",
          city: "",
          latitude: "",
          longitude: "",
          address: "",
          phoneNumber: "",
        },
        destination: {
          id: "",
          name: "",
          city: "",
          latitude: "",
          longitude: "",
          address: "",
          phoneNumber: "",
        },
        koli: 0,
        weight: 0,
        price: "",
        sender: {
          name: "",
          address: "",
          phoneNumber: "",
          zipCode: "",
        },
        recipient: {
          name: "",
          address: "",
          phoneNumber: "",
          zipCode: "",
        },
      };
    },
    /*
     * Sort Function
     */
    sortingApply(value) {
      if (this.sort_order === -1) {
        this.sort_order = 1;
      } else {
        this.sort_order = -1;
      }

      this.sort_by = { [value]: this.sort_order };
      this.getListData(this.page, this.limit);
    },
    convertDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },

    formatPrice(number) {
      var rupiah = "";
      var angkarev = number
        .toString()
        .split("")
        .reverse()
        .join("");
      for (var i = 0; i < angkarev.length; i++)
        if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + ".";
      return rupiah
        .split("", rupiah.length - 1)
        .reverse()
        .join("");
    },
    formatDate(value) {
      let options = { year: "numeric", month: "long", day: "numeric" };
      let date = new Date(value).toLocaleString("id-ID", options);
      return date;
    },
    refreshData() {
      this.getListData(this.page, this.limit);
    },
  },
};
</script>

<style scoped></style>
